import { Icon, IconProps } from '@chakra-ui/react';

export function UndoArrowIcon(props: IconProps): JSX.Element {
  return (
    <Icon
      width="18"
      height="8"
      viewBox="0 0 18 8"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M9.22095 1.08333C7.01261 1.08333 5.01261 1.90833 3.47095 3.25L0.470947 0.25V7.75H7.97095L4.95428 4.73333C6.11261 3.76667 7.58761 3.16667 9.22095 3.16667C12.1709 3.16667 14.6793 5.09167 15.5543 7.75L17.5293 7.1C16.3709 3.60833 13.0959 1.08333 9.22095 1.08333Z"
        fill="currentColor"
      />
    </Icon>
  );
}
